import { api } from './api';

export interface SignupPayload {
    name: string;
    email: string;
    password: string;
    plan_id?: number;
    user_meta?: Record<string, unknown>;
}

export interface AuthUser {
    id: number;
    name: string;
    email: string;
    plan_id?: number | null;
    is_admin: boolean;
    created_at?: string;
    updated_at?: string;
    user_meta?: {
        phone?: string | number;
        role?: string;
        first_name?: string;
        last_name?: string;
    };
}

export interface AuthApiResponse {
    success: boolean;
    message: string;
    data: {
        token: string;
        user: AuthUser;
    };
}

export const signup = (payload: SignupPayload): Promise<AuthApiResponse> =>
    api.post<AuthApiResponse>('/auth/signup', payload);

export interface LoginPayload {
    email: string;
    password: string;
}

export const login = (payload: LoginPayload): Promise<AuthApiResponse> =>
    api.post<AuthApiResponse>('/auth/login', payload);

export interface ChangePasswordPayload {
    old_password: string;
    new_password: string;
}

export interface ChangePasswordResponse {
    success: boolean;
    message: string;
}

export const changePassword = (
    token: string,
    payload: ChangePasswordPayload
): Promise<ChangePasswordResponse> =>
    api.post<ChangePasswordResponse>('/auth/change-password', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
